import React, { useContext } from 'react';
import {
  ModalHeader,
  ModalBody,
  ModalFooter,
  Typography,
  Button,
} from '@one-thd/sui-atomic-components';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { IPaymentCardCommonData } from '../../../models/common/payments';
import { Alert } from '../../shared/alert/alert';
import { IModalBasicProps } from '../../../models/common/modal';
import { GiftCardLogoAndNumber } from '../gift-card/logo-number';

export interface IDisplayGiftCardBalanceModalProps extends IModalBasicProps {
  card: IPaymentCardCommonData;
  balance: string | null;
  errorMessage?: string | false;
}

export const DisplayGiftCardBalance = ({
  card,
  balance,
  hideModal,
  errorMessage = false,
}: IDisplayGiftCardBalanceModalProps) => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';
  return (
    <>
      <ModalHeader onClose={hideModal}>Check Gift Card Balance</ModalHeader>
      <ModalBody>
        <div className="sui-grid sui-flex-col sui-gap-y-6 ">
          {errorMessage ? (
            <Alert status="error">{errorMessage}</Alert>
          ) : (
            <>
              <div className="sui-flex sui-flex-wrap">
                <GiftCardLogoAndNumber card={card} shouldShowInactive />
              </div>

              <Typography variant="body-base">
                Current Balance:{' '}
                <Typography variant="body-base" weight="bold" component="span">
                  ${balance}
                </Typography>
              </Typography>
            </>
          )}
        </div>
      </ModalBody>
      <ModalFooter position={isMobile ? 'center' : 'end'}>
        <div className="sui-flex sui-p-2 sui-gap-4 sm:sui-gap-4 sui-flex-col-reverse sui-w-full sm:sui-flex-row sm:sui-w-auto">
          <Button variant="primary" onClick={hideModal}>
            Close
          </Button>
        </div>
      </ModalFooter>
    </>
  );
};
